export default "__VITE_ASSET__12e6d8f8__"